import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { audioTrackFeature } from "./audio-track.js";
import { bufferFeature } from "./buffer.js";
import { controlsFeature } from "./controls.js";
import { fullscreenFeature } from "./fullscreen.js";
import { liveFeature } from "./live.js";
import { metadataFeature } from "./metadata.js";
import { pipFeature } from "./pip.js";
import { playbackFeature } from "./playback.js";
import { playbackRateFeature } from "./playback-rate.js";
import { qualityFeature } from "./quality.js";
import { remotePlaybackFeature } from "./remote-playback.js";
import { sourceFeature } from "./source.js";
import { streamTypeFeature } from "./stream-type.js";
import { textTrackFeature } from "./text-track.js";
import { timeFeature } from "./time.js";
import { volumeFeature } from "./volume.js";
import { orientationLockFeature } from "./orientation-lock.js";
import { audioFeatures, backgroundFeatures, videoFeatures } from "./presets.js";
//#region src/dom/store/features/feature.parts.ts
var feature_parts_exports = /* @__PURE__ */ __exportAll({
	audioFeatures: () => audioFeatures,
	audioTrack: () => audioTrackFeature,
	backgroundFeatures: () => backgroundFeatures,
	buffer: () => bufferFeature,
	controls: () => controlsFeature,
	fullscreen: () => fullscreenFeature,
	live: () => liveFeature,
	metadata: () => metadataFeature,
	orientationLock: () => orientationLockFeature,
	pip: () => pipFeature,
	playback: () => playbackFeature,
	playbackRate: () => playbackRateFeature,
	quality: () => qualityFeature,
	remotePlayback: () => remotePlaybackFeature,
	source: () => sourceFeature,
	streamType: () => streamTypeFeature,
	textTrack: () => textTrackFeature,
	time: () => timeFeature,
	videoFeatures: () => videoFeatures,
	volume: () => volumeFeature
});
//#endregion
export { audioFeatures, audioTrackFeature as audioTrack, backgroundFeatures, bufferFeature as buffer, controlsFeature as controls, feature_parts_exports, fullscreenFeature as fullscreen, liveFeature as live, metadataFeature as metadata, orientationLockFeature as orientationLock, pipFeature as pip, playbackFeature as playback, playbackRateFeature as playbackRate, qualityFeature as quality, remotePlaybackFeature as remotePlayback, sourceFeature as source, streamTypeFeature as streamType, textTrackFeature as textTrack, timeFeature as time, videoFeatures, volumeFeature as volume };

//# sourceMappingURL=feature.parts.js.map